// extracted by mini-css-extract-plugin
module.exports = {"container":"placeholder_container__rOjIF"};